module.exports = __webpack_public_path__ + "static/lawadvisor-ventures--loop-03-56d7a1b848f9092f046f6fc061663703.mp4";